export default __webpack_public_path__ + "static/media/FRAX.c9bdece8.svg";